import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import {
    DataTableCustomized,
    FilterBar,
} from '@/components/ui/data-table-customized'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useLivechatList } from '../../hooks/use-livechat-list'
import { ChatRoom } from '../../types/response'

const List: React.FC = () => {
    const { t } = useTranslation('livechat')
    const navigate = useNavigate()

    const {
        rooms,
        columns,
        pagination,
        params,
        control,
        filterItems,
        // searchInputProps,
        renderState,
        setFilter,
        handleSortChange,
        handlePageChange,
        handlePageSizeChange,
    } = useLivechatList()

    const stateComponent = renderState()

    return (
        <div>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: '/livechat',
                        title: t('livechat'),
                    },
                ]}
            />

            <Paper className="mt-2 space-y-2">
                <FilterBar
                    control={control}
                    setFilter={setFilter}
                    items={filterItems}
                    hideSearch
                />

                {stateComponent || (
                    <DataTableCustomized<ChatRoom>
                        columns={columns}
                        rows={rooms}
                        rowKey={(row) => row.id}
                        onRowClick={(row) => navigate(`/livechat/${row.id}`)}
                        size="small"
                        resizable
                        toolbar={{
                            settings: {
                                show: true,
                                storageKey: 'livechat-rooms',
                            },
                        }}
                        sorting={{
                            sortBy: params.sort_by,
                            sortOrder: params.sort_order,
                            onSortChange: handleSortChange,
                        }}
                        pagination={{
                            page: params.page,
                            pageSize: params.page_size,
                            total: pagination?.total || 0,
                            onPageChange: handlePageChange,
                            onPageSizeChange: handlePageSizeChange,
                        }}
                        stickyHeader={{
                            enabled: true,
                            offsetTopSelector: '#main-header',
                        }}
                    />
                )}
            </Paper>
        </div>
    )
}

export default List
